import * as React from "react";

const EachRow = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
     
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <g strokeWidth={4}>
        <g stroke="#7B838C">
          <path d="M17 19h6v2h-6zM29 19h6v2h-6zM41 19h6v2h-6z" />
        </g>
        <path stroke="#E9F1FB" d="M17 29h6v2h-6z" />
        <path stroke="#4A90E2" d="M29 29h6v2h-6zM41 29h6v2h-6z" />
        <g>
          <path stroke="#E9F1FB" d="M17 39h6v2h-6z" />
          <path stroke="#4A90E2" d="M29 39h6v2h-6zM41 39h6v2h-6z" />
        </g>
        <g stroke="#7B838C">
          <path d="M17 49h6v2h-6zM29 49h6v2h-6zM41 49h6v2h-6z" />
        </g>
      </g>
      <path
        d="M14.043 31.684L11 34.902l3.043 3.225M16.144 41l1.712-12m2.101 9.127L23 34.908l-3.043-3.224"
        stroke="#4A90E2"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default EachRow;

